import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgFileBigJpg({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 40 40"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M28.25 3.75c1.8 0 3.25 1.46 3.25 3.25v8H29V7a.75.75 0 00-.75-.75h-12.9V12c0 1.65-1.3 3-2.92 3.1H6.5V33c0 .41.34.75.75.75h21c.41 0 .75-.34.75-.75v-3h2.5v3c0 1.8-1.46 3.25-3.25 3.25h-21A3.25 3.25 0 014 33V14c0-.33.13-.65.37-.88l9-9c.23-.24.55-.37.88-.37h14zM16.67 18.06c.33 0 .6.11.8.33.19.22.28.53.28.93v4.5c0 .4-.02.74-.05 1.02-.04.3-.12.59-.24.88-.21.52-.56.92-1.05 1.2a3.3 3.3 0 01-1.74.43 3.6 3.6 0 01-1.54-.3c-.43-.2-.77-.52-1.03-.97a3.45 3.45 0 01-.45-1.67c0-.32.1-.59.29-.77.2-.18.44-.27.72-.27.29 0 .52.08.67.26.15.17.25.4.32.71.06.3.13.53.2.7.05.14.14.27.26.38.12.1.3.14.55.14.63 0 .95-.46.95-1.49v-4.75c0-.4.09-.7.28-.92a1 1 0 01.78-.34zm6.73.15c.68 0 1.2.05 1.58.16a2.4 2.4 0 011.63 1.44c.14.35.2.74.2 1.18 0 .93-.29 1.65-.87 2.14-.58.49-1.43.72-2.54.72H22v2.24c0 .39-.09.7-.3.92a1 1 0 01-.76.34c-.32 0-.58-.12-.78-.34-.2-.21-.3-.52-.3-.91v-6.62c0-.44.11-.76.33-.97.22-.2.55-.3.98-.3h2.23zm9.5-.15c.6 0 1.12.08 1.6.25.46.16.84.36 1.14.62.3.25.52.51.67.8.16.29.24.55.24.79 0 .27-.1.51-.3.7a1.02 1.02 0 01-1.55-.14 6.76 6.76 0 00-.52-.73 1.64 1.64 0 00-.54-.39 2.1 2.1 0 00-.88-.15c-.37 0-.7.06-1 .19-.28.12-.53.3-.73.55-.21.24-.37.54-.48.9a4.1 4.1 0 00-.17 1.2c0 .97.22 1.7.65 2.2.42.5 1 .75 1.78.75.38 0 .74-.05 1.08-.15.3-.1.61-.22.93-.38v-1.08h-1.15c-.36 0-.63-.05-.84-.17-.23-.14-.34-.37-.34-.67a.8.8 0 01.27-.62 1 1 0 01.7-.24h1.97c.26 0 .48.02.67.07.21.05.4.18.52.37.13.18.2.44.2.78v1.64c0 .24-.03.44-.08.6-.06.16-.15.3-.3.43-.12.12-.28.23-.48.33a6.25 6.25 0 01-5.04.52 4 4 0 01-2.38-2.4 5.46 5.46 0 01-.32-1.92c0-.7.1-1.33.3-1.9a3.96 3.96 0 012.42-2.43 5.61 5.61 0 011.95-.32zm-9.92 1.86H22v2.22h.97c.39 0 .71-.04.97-.12a1 1 0 00.53-.35c.11-.16.17-.37.17-.65 0-.33-.09-.59-.27-.78-.19-.19-.58-.3-1.2-.32h-.2zM13.15 7.87L8.12 12.9h4.13a.9.9 0 00.9-.79V7.87z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgFileBigJpg.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgFileBigJpg.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgFileBigJpg svgRef={ref} {...props} />);
export default ForwardRef;
